export const CHART_BUILDER_RUN_START = 'CHART_BUILDER_RUN_START';
export const CHART_BUILDER_RUN_SUCCESS = 'CHART_BUILDER_RUN_SUCCESS';
export const CHART_BUILDER_RUN_FAIL = 'CHART_BUILDER_RUN_FAIL';
export const CHART_BUILDER_CLEAR = 'CHART_BUILDER_CLEAR';

export const FETCH_DASHBOARD_SETTINGS_START = 'FETCH_DASHBOARD_SETTINGS_START';
export const FETCH_DASHBOARD_SETTINGS_SUCCESS = 'FETCH_DASHBOARD_SETTINGS_SUCCESS';
export const FETCH_DASHBOARD_SETTINGS_FAIL = 'FETCH_DASHBOARD_SETTINGS_FAIL';

export const SAVE_DASHBOARD_SETTINGS_START = 'SAVE_DASHBOARD_SETTINGS_START';
export const SAVE_DASHBOARD_SETTINGS_SUCCESS = 'SAVE_DASHBOARD_SETTINGS_SUCCESS';
export const SAVE_DASHBOARD_SETTINGS_FAIL = 'SAVE_DASHBOARD_SETTINGS_FAIL';
